export const GAIN_MAX = 5;
export const GAIN_PADDING = 4;
export const GAIN_OFFSET = 1 / 3;
export const GAIN_MIN_LOG = Math.log(0 + GAIN_OFFSET);
export const GAIN_CENTER_LOG = Math.log(1 + GAIN_OFFSET);
export const GAIN_MAX_LOG = Math.log(GAIN_MAX + GAIN_OFFSET);

export function gainToNormalized(g) {
  const clamped = Math.max(0, Math.min(GAIN_MAX, g));
  if (clamped <= 1) {
    const logVal = Math.log(clamped + GAIN_OFFSET);
    return 0.5 * (logVal - GAIN_MIN_LOG) / (GAIN_CENTER_LOG - GAIN_MIN_LOG);
  }
  const logVal = Math.log(clamped + GAIN_OFFSET);
  return 0.5 + 0.5 * (logVal - GAIN_CENTER_LOG) / (GAIN_MAX_LOG - GAIN_CENTER_LOG);
}

export function normalizedToGain(n) {
  const clamped = Math.max(0, Math.min(1, n));
  if (clamped <= 0.5) {
    const logVal = GAIN_MIN_LOG + (clamped / 0.5) * (GAIN_CENTER_LOG - GAIN_MIN_LOG);
    return Math.exp(logVal) - GAIN_OFFSET;
  }
  const logVal = GAIN_CENTER_LOG + ((clamped - 0.5) / 0.5) * (GAIN_MAX_LOG - GAIN_CENTER_LOG);
  return Math.exp(logVal) - GAIN_OFFSET;
}

export function gainToY(g, height) {
  const drawHeight = height - GAIN_PADDING * 2;
  const drawBottom = height - GAIN_PADDING;
  return drawBottom - gainToNormalized(g) * drawHeight;
}

export function yToGain(y, height) {
  const drawHeight = height - GAIN_PADDING * 2;
  const drawBottom = height - GAIN_PADDING;
  const normalized = (drawBottom - y) / drawHeight;
  return normalizedToGain(normalized);
}
